import { useState, useEffect, useContext, useRef } from "react";
import { FaArrowRight, FaTimes, FaUpload, FaArrowCircleRight } from "react-icons/fa";
import Lottie from "lottie-react";
import 'animate.css';
import { useNavigate, useLocation } from 'react-router-dom';
import claimAnimation from "../assets/claimAnimation.json";
import policyAnimation from "../assets/policyAnimation.json";
import webinarAnimation from "../assets/webinarAnimation.json";
import sliderimage1 from '../assets/sliderimage1.webp';
import sliderimage2 from '../assets/sliderimage2.webp';
import sliderimage3 from '../assets/sliderimage3.webp';
import sliderimage4 from '../assets/sliderimage4.webp';
import '../css/hero.css';
import axios from "axios";
import { UserContext } from "../UserContext";
import { fromJSON } from "tough-cookie";
import { faListSquares } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from 'react-helmet-async';

const sliderData = [
  {
    image: sliderimage1,
    title: 'One Platform To Understand  All Insurance In India. ',
    subtitle: 'Whether buying or renewing, our platform ensures youre never in the dark again',
  },
  {
    image: sliderimage2,
    title: 'We Simplify Policies So You Stay Stress-Free.',
    subtitle: 'Save time, avoid confusion, and make confident decisions about your insurance.',
  },
  {
    image: sliderimage3,
    title: 'Be Insurance Smart With Every  Policy You Buy',
    subtitle: 'Our insights help you avoid mistakes and choose policies that protect your needs.',
  },
  {
    image: sliderimage4,
    title: 'Research Compare Make  Confident Choices',
    subtitle: 'Your go-to platform for all things insurance in India. Whether it\'s buying or renewing, we provide the clarity you need to make smart decisions.',
  },
];

function getYouTubeID(url) {
  try {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|shorts\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  } catch {
    return null;
  }
}

function HeroSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const [isPolicyModalOpen, setIsPolicyModalOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [modalVideo, setModalVideo] = useState(null);
  const currentSlide = sliderData[currentIndex];
  const [InquriyDocument, setInquriyDocument] = useState();
  const [Successmessage, setSuccessMessage] = useState("");
  const [Errormessage, setErrorMessage] = useState("");
  const [nameFieldError, setNameFieldError] = useState('');
  const [mobileFieldError, setMobileFieldError] = useState('');
  const [mobileError, setMobileError] = useState('');
  const [timeError, setTimeError] = useState('');
  const [dateError, setDateError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [InquiryType, setInquiryType] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [Message, setMessage] = useState();
  const [OTP, setOtp] = useState("");
  const [getPoliciesError, setGetPoliciesError] = useState();
  const [videoSlides, setvideoSlides] = useState([]);
  const fileInputRef = useRef(null);
  const [showSweetAlert, setShowSweetAlert] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [touchedFields, setTouchedFields] = useState({});
  const [WebinarDetails, setWebinarDetails] = useState([]);
  const [isWebinarNull, setisWebinarNull] = useState(false);
  const duplicatedSlides = [...videoSlides, ...videoSlides];
  const { UserId, user, UserToken, userRole, UserEmail, UserMobile } = useContext(UserContext);

  const isLoggedIn = !!(user && UserToken && userRole);
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    MobileNo: "",
    Time: "",
    Date: "",
    webinarTopic: "",
    AdditionalDetails: "",
    YourClaimIssue: "",
    WebinarId: ""
  });
  const API_URL = process.env.REACT_APP_Dashboard_API_URL;
  const API_URL_User = process.env.REACT_APP_Login_API_URL;

  const openVideoModal = (videoUrl) => {
    const videoId = getYouTubeID(videoUrl);
    setModalVideo(`https://www.youtube.com/embed/${videoId}`);
  };

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    setIsPolicyModalOpen(false);
    setIsContactModalOpen(false);
    setIsRegisterModalOpen(false);

    if (path === "/apnipolicysamjho") {
      setIsPolicyModalOpen(true);
    } else if (path === "/freeclaimconsultancy") {
      setIsContactModalOpen(true);
    } else if (path === "/registerwebinar") {
      setIsRegisterModalOpen(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    let timer;
    if (showSweetAlert) {
      timer = setTimeout(() => {
        setShowSweetAlert(false);
      }, 5000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [showSweetAlert]);

  const closeModal = () => {
    setModalVideo(null);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const showFieldError = (fieldName, specificError) => {
    if (fieldName === 'Name' || fieldName === 'MobileNo' ||
      fieldName === 'YourClaimIssue' || fieldName === 'webinarTopic') {
      return (!formData[fieldName] && (touchedFields[fieldName] || formSubmitted)) ? (
        <div className="hero-bottom-popup-error">
          {fieldName === 'Name' ? 'Full name is required' :
            fieldName === 'MobileNo' ? 'Mobile number is required' :
              fieldName === 'YourClaimIssue' ? 'Your Claim Issue is required' :
                fieldName === 'webinarTopic' ? 'Webinar topic is required' :
                  'Your Claim Issue is required'}
        </div>
      ) : null;
    }

    if (specificError && (touchedFields[fieldName] || formSubmitted)) {
      return <div className="hero-bottom-popup-error">{specificError}</div>;
    }
    if (!formData[fieldName] && (touchedFields[fieldName] || formSubmitted)) {
      return <div className="hero-bottom-popup-error">
        {fieldName === 'Email' ? 'Email is required' :
          fieldName === 'Date' ? 'Date is required' :
            'Time is required'}
      </div>;
    }
    return null;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Email address is required';
    }
    return '';
  };

  const validateMobile = (mobile) => {
    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobile) {
      return 'Mobile number is required';
    }
    if (!mobileRegex.test(mobile)) {
      return 'Please enter a valid Mobile number';
    }
    return '';
  };

  const validateDate = (date) => {
    if (!date) {
      return 'Date is required';
    }
    const today = new Date();
    const selectedDate = new Date(date + 'T00:00:00');
    if (selectedDate < new Date(today.toDateString())) {
      return 'You cannot select a past date';
    }
    return '';
  };

  const validateTime = (time) => {
    if (!time) {
      return 'Time is required';
    }
    return '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'Name') {
      setFormData({ ...formData, [name]: value });
      setTouchedFields({ ...touchedFields, [name]: true });
      if (/^[A-Za-z\s]*$/.test(value) || value === "") {
        setNameFieldError("");
      } else {
        setNameFieldError("Please enter valid full name ");
      }
      return;
    }

    if (name === 'MobileNo') {
      setFormData({ ...formData, [name]: value });
      setTouchedFields({ ...touchedFields, [name]: true });
      const mobileRegex = /^[6-9]\d{0,9}$/;
      if (value === "" || mobileRegex.test(value)) {
        setMobileFieldError("");
      } else {
        setMobileFieldError("Please enter valid mobile number");
      }
      return;
    }

    setFormData({ ...formData, [name]: value });
    setTouchedFields({ ...touchedFields, [name]: true });

    if (name === 'Email') setEmailError('');
    else if (name === 'MobileNo') setMobileError('');
    else if (name === 'Date') setDateError('');
    else if (name === 'Time') setTimeError('');
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setFormSubmitted(true);
    const emailErr = validateEmail(formData.Email);
    const mobileErr = validateMobile(formData.MobileNo);
    const dateErr = validateDate(formData.Date);
    const timeErr = validateTime(formData.Time);

    setEmailError(emailErr);
    setMobileError(mobileErr);
    setDateError(dateErr);
    setTimeError(timeErr);

    if (
      emailErr ||
      mobileErr ||
      dateErr ||
      timeErr ||
      !formData.Name ||
      (isContactModalOpen && !formData.YourClaimIssue)
    ) {
      return;
    }

    // Extract date/time
    const { Date: selectedDate, Time: selectedTime } = formData;

    if (!selectedDate || !selectedTime) {
      setErrorMessage('Please select both date and time.');
      return;
    }

    const today = new Date();
    const selectedDateObj = new Date(selectedDate + 'T00:00:00');

    // Prevent past date
    if (selectedDateObj < new Date(today.toDateString())) {
      setErrorMessage('You cannot select a past date.');
      return;
    }

    // Prevent time in the past when same day
    const [hours, minutes] = selectedTime.split(':').map(Number);
    const meetingDateTime = new Date(
      selectedDateObj.getFullYear(),
      selectedDateObj.getMonth(),
      selectedDateObj.getDate(),
      hours,
      minutes,
      0
    );

    const now = new Date();
    if (selectedDateObj.toDateString() === now.toDateString()) {
      const nowPlus30Min = new Date(now.getTime() + 30 * 60000);
      if (meetingDateTime <= nowPlus30Min) {
        setErrorMessage("For today's date, time must be at least 30 minutes ahead of the current time.");
        return;
      }
    }

    setErrorMessage('');
    setIsDisabled(true);

    // Prepare FormData
    const inquriyData = new FormData();
    inquriyData.append("Name", formData.Name);
    inquriyData.append("Email", formData.Email);
    inquriyData.append("InquiryType", InquiryType);
    inquriyData.append("PreferredDate", formData.Date);
    inquriyData.append("PreferredTime", formData.Time);
    inquriyData.append("MobileNo", formData.MobileNo);
    inquriyData.append("WebinarTopic", formData.webinarTopic);
    inquriyData.append("AdditionalDetails", formData.AdditionalDetails);
    inquriyData.append("Status", "New");
    inquriyData.append("UserId", UserId);
    inquriyData.append("YourClaimIssue", formData.YourClaimIssue);
    inquriyData.append("WebinarId", formData.WebinarId);
    inquriyData.append("InquriyDocument", InquriyDocument);
    inquriyData.append("IsLoggedIn", isLoggedIn);
    inquriyData.append("Otp", OTP);

    try {
      const response = await axios.post(`${API_URL}AddNewInquiries`, inquriyData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.status === 200) {
        setFormData({
          Name: "",
          Email: "",
          MobileNo: "",
          Time: "",
          Date: "",
          webinarTopic: "",
          YourClaimIssue: "",
          WebinarId: "",
          AdditionalDetails: ""
        });

        setEmailError("");
        setMobileError("");
        setDateError("");
        setTimeError("");
        setErrorMessage("");
        setFormSubmitted(false);
        setTouchedFields({});

        setShowSweetAlert(true);

        setTimeout(() => {
          setShowOtpPopup(false);
          setOtp("");
          setMessage("");
          setSuccessMessage("");
          if (fileInputRef.current) {
            fileInputRef.current.value = null;
          }
          setIsDisabled(false);
          setIsRegisterModalOpen(false);
          setIsContactModalOpen(false);
          setIsPolicyModalOpen(false);
        }, 2000);
      }
      else if (response.status === 202) {
        setShowOtpPopup(true);
        setSuccessMessage(response.data.message);
        setTimeout(() => {
          setSuccessMessage('');
        }, 3000);
      } else {
        setMessage(response.data.message);
        setOtp("");
      }
    } catch (error) {
      setSuccessMessage("");
      setMessage(error.response?.data?.message);
      setTimeout(() => {
        setOtp("");
        setMessage("");
        setEmailError("");
        setMobileError("");
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
      }, 5000);
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const maxSize = 5 * 1024 * 1024; // 5 MB
      if (file.size > maxSize) {
        setErrorMessage("File size should not exceed 5 MB.");
        return;
      }
      setInquriyDocument(file);
    }
  };

  const UserDetails = async (user, UserEmail, UserMobile) => {
    if (user, UserEmail, UserMobile) {
      setFormData(prev => ({
        ...prev,
        id: UserId,
        Name: user,
        Email: UserEmail,
        MobileNo: UserMobile
      }));
    }
  };

  const handleResendOtp = async () => {
    setOtp("");
    handleSubmit();
  };

  useEffect(() => {
    getAllPolicies();
  }, []);

  const getAllPolicies = async () => {
    try {
      const response = await axios.get(API_URL + "AllPolicies");
      if (response.status === 200) {
        const transformedPolicies = response.data.filter(policy => policy.productCategory === "General Awareness");;
        setvideoSlides(transformedPolicies);
        if (transformedPolicies.length === 0) {
          setGetPoliciesError("Policies Video Not Found");
        }
      } else {
        setGetPoliciesError("Policies Video Not Found");
      }
    } catch (error) {
      setGetPoliciesError("Policies Video Not Found");
    }
  };

  const GetUpcomingWebinar = async (setWebinarDetails, setisWebinarNull) => {
    try {
      const response = await axios.get(API_URL + "GetActiveWebinar");
      if (response.status === 200) {
        const upcomingWebinar = response.data;
        if (upcomingWebinar) {
          setWebinarDetails(upcomingWebinar);
          setFormData(prev => ({
            ...prev,
            WebinarId: upcomingWebinar.id,
            Date: upcomingWebinar.webinarDate,
            Time: upcomingWebinar.webinarTime,
            webinarTopic: upcomingWebinar.webinarTopic,
            AdditionalDetails: upcomingWebinar.additionalDetails
          }));

        } else {

          setisWebinarNull(true);

          setWebinarDetails([]);
        }
      } else {
        setisWebinarNull(true);
        setWebinarDetails([]);
      }
    } catch (error) {
      setisWebinarNull(true);
      setWebinarDetails([]);
    }
  };
  return (
    <div className="home-hero-container">
      <Helmet>
        <title>Insurance Policy Review | Understand Your Coverage Clearly</title>
        <meta
          name="description"
          content="Not sure what your policy covers? Upload it now and receive clear, personalized expert advice. Get your insurance policy reviewed by experts to understand your coverage fully and avoid costly mistakes."
        />
        <meta
          name="keywords"
          content="insurance guidance, policy consultation, insurance expert advice, clarity in insurance, compare insurance policies, best insurance policies India, insurance policy review, policy upload, personalized insurance recommendations India, insurance policy explanation, insurance advice India, insurance policy help, understand insurance policy, insurance policy consultation India, how to understand your insurance policy, upload insurance policy for advice, personalized insurance advice in India, insurance policy mistakes to avoid, best health insurance plan advice, what does an insurance policy cover, insurance policy explanations for beginners, compare term insurance plans India, insurance consultation near me, insurance experts for personalized advice, insurance policy FAQs India"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Life Insurance Advice",
            "description": "Clear, expert guidance to help you choose the right life insurance policy for your needs. Compare plans, understand coverage, and get unbiased advice from the experts at Policy Samjho.",
            "provider": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com/"
            },
            "serviceType": "Life Insurance Consultation & Policy Guidance",
            "areaServed": "IN",
            "url": "https://policysamjho.com/life-insurance-advice/",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9584484800",
              "email": "info@policysamjho.com",
              "contactType": "customer service"
            }
          })}
        </script>
      </Helmet>
      <div className="home-hero-top">
        <div className="home-hero-left">
          <h1 className="home-hero-title">
            <span className="title-part1">{currentSlide.title.split(' ').slice(0, Math.ceil(currentSlide.title.split(' ').length / 2)).join(' ')}</span>
            <span className="title-part2">{currentSlide.title.split(' ').slice(Math.ceil(currentSlide.title.split(' ').length / 2)).join(' ')}</span>
          </h1>
          <p className="home-hero-subtitle" style={{ fontFamily: 'Plut Lakarta Sans, sans-serif' }} >{currentSlide.subtitle}</p>
          <div className="hero-top-video-slider-container">
            <div className="hero-top-video-slider-track" style={{ animationDuration: `${videoSlides.length * 5}s` }}>
              {videoSlides.concat(videoSlides).map((video, idx) => (
                <div key={idx} className="hero-top-video-slide">
                  <div className="hero-top-video-thumbnail" onClick={() => openVideoModal(video.video)}>
                    <img
                      src={`https://img.youtube.com/vi/${getYouTubeID(video.video)}/0.jpg`}
                      alt={`Video ${idx}`}
                    />
                    <div className="hero-top-play-icon">▶</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {modalVideo && (
            <div className="video-modal-overlay" onClick={closeModal}>
              <div className="video-modal-content" onClick={e => e.stopPropagation()}>
                <iframe
                  src={`${modalVideo}?autoplay=1`}
                  title="Popup Video"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  frameBorder="0"
                />
                <button className="modal-close-btn" onClick={closeModal}>
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>
          )}

        </div>
        <div className="home-hero-right">
          <div className="home-image-right">
            <img
              src={currentSlide.image}
              alt={`Slide ${currentIndex + 1}`}
              className="home-hero-image"
            />
          </div>
        </div>
      </div>
      <div className="home-hero-bottom">
        <div className="hero-bottom-option" onClick={() => { setIsPolicyModalOpen(true), setInquiryType("Policy Review"), isLoggedIn ? UserDetails(user, UserEmail, UserMobile) : null; }}>
          <div className="hero-home-lottie-container lottie-container1">
            <Lottie animationData={policyAnimation} />
          </div>
          <div className="hero-bottom-textbtn">
            <p className="hero-bottom-text contact-bounce">Click Here For Apni Policy Samjho</p>
            <button className="hero-buttons">Click here</button>
          </div>
        </div>
        <hr className="mobile-divider" />
        <div className="hero-bottom-option" onClick={() => { setIsContactModalOpen(true), setInquiryType("Claim Inquiry"), isLoggedIn ? UserDetails(user, UserEmail, UserMobile) : null; }}>
          <div className="hero-home-lottie-container lottie-container2">
            <Lottie animationData={claimAnimation} />
          </div>
          <div className="hero-bottom-textbtn">
            <p className="hero-bottom-text contact-bounce">Click Here For FREE Claim Consultancy</p>
            <button className="hero-buttons">Click here</button>
          </div>
        </div>
        <hr className="mobile-divider" />
        <div className="hero-bottom-option" onClick={() => { setIsRegisterModalOpen(true), setInquiryType("Webinars Inquiry"), GetUpcomingWebinar(setWebinarDetails, setisWebinarNull), isLoggedIn ? UserDetails(user, UserEmail, UserMobile) : null; }}>
          <div className="hero-home-lottie-container lottie-container3">
            <Lottie animationData={webinarAnimation} />
          </div>
          <div className="hero-bottom-textbtn">
            <p className="hero-bottom-text contact-bounce">Register Now For Webinar</p>
            <button className="hero-buttons">Click here</button>
          </div>
        </div>
      </div>


      {isPolicyModalOpen && (
        <div className="home-hero-bottom-popup">
          {showOtpPopup && (
            <div className="hero-otp-popup">
              <div className="hero-otp-content">
                <FaTimes className="close-otp-popup" onClick={() => setShowOtpPopup(false)} />
                <h2 className="hero-otp-popup-heading">Enter OTP</h2>
                <input
                  type="tel"
                  maxLength={6}
                  value={OTP}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter 6-digit OTP"
                  className="otp-input"
                />
                <button onClick={handleSubmit} className="verify-otp-btn">
                  Verify OTP
                </button>
                <p className="resend-popup-otp-text" onClick={handleResendOtp}>
                  <span>Resend OTP</span>
                </p>
                {Message && (
                  <p className={Message.includes("OTP Verified Successfully !") ? "hero-otppopup-success" : "hero-otppopup-error"}>
                    {Message}
                  </p>
                )}
                {Successmessage && <div className="hero-bottom-popup-success">{Successmessage}</div>}
              </div>
            </div>
          )}
          <div className="bottom-popup-content">
            <FaTimes className="bottom-popup-close-btn" onClick={() => {
              setIsPolicyModalOpen(false);
              setIsDisabled(false);
              setEmailError("");
              setMobileError("");
              setTimeError("");
              setDateError("");
              setFormData({
                Name: "",
                Email: "",
                MobileNo: "",
                Time: "",
                Date: "",
                webinarTopic: "",
                YourClaimIssue: "",
                WebinarId: "",
                AdditionalDetails: ""
              });
              setErrorMessage("");
              setTouchedFields({});
              setFormSubmitted(false);
              if (fileInputRef.current) {
                fileInputRef.current.value = null;
              }
            }} />
            <h2>
              <span className="popup-heading-primary">Understand Your </span>
              <span className="popup-heading-secondary">Policy More</span>
            </h2>
            <form onSubmit={handleSubmit}>
              <div className="bottom-form-row">
                <div>
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="Name"
                    placeholder="Enter your name"
                    value={formData.Name || user}
                    onChange={handleChange}
                    readOnly={isLoggedIn}
                  />
                  {(!formData.Name && formSubmitted) && (
                    <div className="hero-bottom-popup-error">Full name is required</div>
                  )}
                  {formData.Name && nameFieldError && (
                    <div className="hero-bottom-popup-error">{nameFieldError}</div>
                  )}
                </div>
                <div>
                  <label>Email ID</label>
                  <input
                    type="email"
                    name="Email"
                    placeholder="Enter your email"
                    value={formData.Email || UserEmail}
                    onChange={handleChange}
                    readOnly={isLoggedIn}
                  />
                  {showFieldError('Email', emailError)}
                </div>
              </div>
              <div className="bottom-form-row">
                <div>
                  <label>Mobile No</label>
                  <input
                    type="tel"
                    name="MobileNo"
                    placeholder="Enter mobile number"
                    value={formData.MobileNo || UserMobile}
                    onChange={handleChange}
                    maxLength={10}
                    readOnly={isLoggedIn}
                  />
                  {(!formData.MobileNo && formSubmitted) && (
                    <div className="hero-bottom-popup-error">Mobile number is required</div>
                  )}
                  {formData.MobileNo && mobileFieldError && (
                    <div className="hero-bottom-popup-error">{mobileFieldError}</div>
                  )}

                </div>
                <div>
                  <label>Preference Date</label>
                  <input
                    type="date"
                    name="Date"
                    value={formData.Date}
                    onChange={handleChange}
                  />
                  {showFieldError('Date', dateError)}
                </div>
              </div>
              <div className="bottom-form-row">
                <div>
                  <label>Preference Time</label>
                  <input
                    type="time"
                    name="Time"
                    value={formData.Time}
                    onChange={handleChange}
                  />
                  {showFieldError('Time', timeError)}
                </div>
                <div>
                  <label>Upload Policy Documents</label>
                  <label htmlFor="policy-file" className="file-upload-label">
                    <span className="file-upload-button">Choose File</span>
                    <span className="file-name">{fileInputRef.current?.files[0]?.name || "No file chosen"}</span>
                    <input
                      id="policy-file"
                      type="file"
                      className="file-upload-input"
                      onChange={handleFileChange}
                      accept="*/*"
                      ref={fileInputRef}
                    />
                  </label>
                </div>
              </div>
              <button type="submit" disabled={isDisabled}>Submit</button>

              {Errormessage && <div className="hero-bottom-popup-error">{Errormessage}</div>}
            </form>
          </div>
        </div>
      )}

      {isContactModalOpen && (
        <div className="home-hero-bottom-popup">
          {showOtpPopup && (
            <div className="hero-otp-popup">
              <div className="hero-otp-content">
                <FaTimes className="close-otp-popup" onClick={() => setShowOtpPopup(false)} />
                <h2 className="hero-otp-popup-heading">Enter OTP</h2>
                <input
                  type="tel"
                  maxLength={6}
                  value={OTP}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter 6-digit OTP"
                  className="otp-input"
                />
                <button onClick={handleSubmit} className="verify-otp-btn">
                  Verify OTP
                </button>
                <p className="resend-popup-otp-text" onClick={handleResendOtp}>
                  <span>Resend OTP</span>
                </p>
                {Message && (
                  <p className={Message.includes("OTP Verified Successfully !") ? "hero-otppopup-success" : "hero-otppopup-error"}>
                    {Message}
                  </p>
                )}
                {Successmessage && <div className="hero-bottom-popup-success">{Successmessage}</div>}
              </div>
            </div>
          )}
          <div className="bottom-popup-content">
            <FaTimes
              className="bottom-popup-close-btn"
              onClick={() => {
                setIsContactModalOpen(false);
                setIsDisabled(false);
                setEmailError("");
                setMobileError("");
                setTimeError("");
                setDateError("");
                setFormData({
                  Name: "",
                  Email: "",
                  MobileNo: "",
                  Time: "",
                  Date: "",
                  webinarTopic: "",
                  YourClaimIssue: "",
                  WebinarId: "",
                  AdditionalDetails: ""
                });
                setErrorMessage("");
                setTouchedFields({});
                setFormSubmitted(false);
                if (fileInputRef.current) {
                  fileInputRef.current.value = null;
                }
              }}
            />
            <h2>
              <span className="popup-heading-primary">Complimentary Complete </span>
              <span className="popup-heading-secondary">Claim Assistance</span>
            </h2>
            <form onSubmit={handleSubmit}>
              <div className="bottom-form-row">
                <div>
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="Name"
                    placeholder="Enter your name"
                    value={formData.Name || user}
                    onChange={handleChange}
                    readOnly={isLoggedIn}
                  />
                  {(!formData.Name && formSubmitted) && (
                    <div className="hero-bottom-popup-error">Full name is required</div>
                  )}
                  {formData.Name && nameFieldError && (
                    <div className="hero-bottom-popup-error">{nameFieldError}</div>
                  )}
                </div>
                <div>
                  <label>Email ID</label>
                  <input
                    type="email"
                    name="Email"
                    placeholder="Enter your email"
                    value={formData.Email || UserEmail}
                    onChange={handleChange}
                    readOnly={isLoggedIn}
                  />
                  {showFieldError('Email', emailError)}
                </div>
              </div>
              <div className="bottom-form-row">
                <div>
                  <label>Mobile No</label>
                  <input
                    type="tel"
                    name="MobileNo"
                    placeholder="Enter mobile number"
                    value={formData.MobileNo || UserMobile}
                    onChange={handleChange}
                    maxLength={10}
                    readOnly={isLoggedIn}
                  />
                  {(!formData.MobileNo && formSubmitted) && (
                    <div className="hero-bottom-popup-error">Mobile number is required</div>
                  )}
                  {formData.MobileNo && mobileFieldError && (
                    <div className="hero-bottom-popup-error">{mobileFieldError}</div>
                  )}
                </div>
                <div>
                  <label>Preference Date</label>
                  <input
                    type="date"
                    name="Date"
                    value={formData.Date}
                    onChange={handleChange}
                  />
                  {showFieldError('Date', dateError)}
                </div>
              </div>
              <div className="bottom-form-row">
                <div>
                  <label>Preference Time</label>
                  <input
                    type="time"
                    name="Time"
                    value={formData.Time}
                    onChange={handleChange}
                  />
                  {showFieldError('Time', timeError)}
                </div>
                <div>
                  <label>Upload Documents</label>
                  <label htmlFor="claim-file" className="file-upload-label">
                    <span className="file-upload-button">Choose File</span>
                    <span className="file-name">{fileInputRef.current?.files[0]?.name || "No file chosen"}</span>
                    <input
                      id="claim-file"
                      type="file"
                      className="file-upload-input"
                      onChange={handleFileChange}
                      accept="*/*"
                      ref={fileInputRef}
                    />
                  </label>
                </div>
              </div>
              <div className="bottom-form-row">
                <div>
                  <label>Your Claim Issue</label>
                  <input
                    type="text"
                    name="YourClaimIssue"
                    placeholder="Describe your claim issue"
                    value={formData.YourClaimIssue}
                    onChange={handleChange}
                  />
                  {showFieldError('YourClaimIssue')}
                </div>
              </div>
              <button type="submit" disabled={isDisabled}>Submit</button>

              {Errormessage && <div className="hero-bottom-popup-error">{Errormessage}</div>}
            </form>
          </div>
        </div>
      )}

      {isRegisterModalOpen && (
        <div className="home-hero-bottom-popup">
          {showOtpPopup && (
            <div className="hero-otp-popup">
              <div className="hero-otp-popup">
                <div className="hero-otp-content">
                  <FaTimes className="close-otp-popup" onClick={() => setShowOtpPopup(false)} />
                  <h2 className="hero-otp-popup-heading">Enter OTP</h2>
                  <input
                    type="tel"
                    maxLength={6}
                    value={OTP}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter 6-digit OTP"
                    className="otp-input"
                  />
                  <button onClick={handleSubmit} className="verify-otp-btn-register">
                    Verify OTP
                  </button>
                  <p className="resend-popup-otp-text" onClick={handleResendOtp}>
                    <span>Resend OTP</span>
                  </p>
                  {Message && (
                    <p className={Message.includes("OTP Verified Successfully !") ? "hero-otppopup-success" : "hero-otppopup-error"}>
                      {Message}
                    </p>
                  )}
                  {Successmessage && <div className="hero-bottom-popup-success">{Successmessage}</div>}
                </div>
              </div>
            </div>
          )}
          <div className="bottom-popup-content">
            <FaTimes className="bottom-popup-close-btn" onClick={() => {
              setIsRegisterModalOpen(false);
              setIsDisabled(false);
              setEmailError("");
              setMobileError("");
              setTimeError("");
              setDateError("");
              setFormData({
                Name: "",
                Email: "",
                MobileNo: "",
                Time: "",
                Date: "",
                webinarTopic: "",
                YourClaimIssue: "",
                WebinarId: "",
                AdditionalDetails: ""
              });
              setErrorMessage("");
              setTouchedFields({});
              setFormSubmitted(false);
              if (fileInputRef.current) {
                fileInputRef.current.value = null;
              }
            }} />

            {isWebinarNull !== true ? (
              <>
                <h2>
                  <span className="popup-heading-primary">Quickly Register </span>
                  <span className="popup-heading-secondary">For Webinar</span>
                </h2>
                <form onSubmit={handleSubmit}>
                  <div className="bottom-form-row">
                    <div>
                      <label>Webinar Date</label>
                      <input
                        type="date"
                        placeholder="Webinar Date"
                        value={formData.Date}
                        readOnly
                      />
                    </div>
                    <div>
                      <label>Webinar Time</label>
                      <input
                        type="time"
                        placeholder="Webinar Time"
                        value={formData.Time}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="bottom-form-row">
                    <div className="webinar-topic-tooltip-container">
                      <label className="form-label-feedback">Webinar Topic</label>
                      <div className="webinar-topic-tooltip-box">{formData.webinarTopic}</div>
                      <input
                        type="text"
                        placeholder="Enter your webinar topic"
                        value={formData.webinarTopic}
                        readOnly
                        className="feedback-input"
                      />
                    </div>

                    <div className="tooltip-container">
                      <label className="form-label-feedback">Additional Webinar Details</label>
                      <div className="tooltip-box">
                        {formData.AdditionalDetails}
                      </div>
                      <textarea
                        placeholder="Your additional webinar details here..."
                        value={formData.AdditionalDetails}
                        className="feedback-textarea"
                        readOnly
                      />
                    </div>

                  </div>
                  <div className="bottom-form-row">
                    <div>
                      <label> Full Name</label>
                      <input
                        type="text"
                        name="Name"
                        placeholder="enter your name"
                        value={formData.Name || user}
                        onChange={handleChange}
                        readOnly={isLoggedIn}
                      />
                      {(!formData.Name && formSubmitted) && (
                        <div className="hero-bottom-popup-error">Full name is required</div>
                      )}
                      {formData.Name && nameFieldError && (
                        <div className="hero-bottom-popup-error">{nameFieldError}</div>
                      )}
                    </div>
                    <div>
                      <label>Email ID </label>
                      <input
                        type="email"
                        name="Email"
                        placeholder="enter your email"
                        value={formData.Email || UserEmail}
                        onChange={handleChange}
                        readOnly={isLoggedIn}
                      />
                      {showFieldError('Email', emailError)}
                    </div>
                  </div>
                  <div className="bottom-form-row">
                    <div>
                      <label>Mobile No</label>
                      <input
                        type="tel"
                        name="MobileNo"
                        placeholder="enter you mobile number"
                        value={formData.MobileNo || UserMobile}
                        onChange={handleChange}
                        maxLength={10}
                        readOnly={isLoggedIn}
                      />
                      {(!formData.MobileNo && formSubmitted) && (
                        <div className="hero-bottom-popup-error">Mobile number is required</div>
                      )}
                      {formData.MobileNo && mobileFieldError && (
                        <div className="hero-bottom-popup-error">{mobileFieldError}</div>
                      )}
                    </div>
                  </div>

                  <button type="submit" disabled={isDisabled}>Submit</button>

                  {Errormessage && (<div className="hero-bottom-popup-error">{Errormessage}</div>)}
                </form>
              </>
            ) : (
              <div className="hero-bottom-popup-error">Webinar not available</div>
            )}

          </div>
        </div>
      )}

      {
        showSweetAlert && (
          <div className="hero-sweet-alert-container">
            <div className="hero-sweet-alert-content">
              <button
                onClick={() => setShowSweetAlert(false)}
                className="hero-sweet-alert-close-btn"
              >
                ×
              </button>
              <div className="hero-sweet-alert-tick-icon">
                <i className="fas fa-check"></i>
              </div>
              <h2 className="hero-sweet-alert-title">Success!</h2>
              <p className="hero-sweet-alert-text">
                Inquiry added successfully <br />
                Our expert will call you soon.
              </p>
            </div>
          </div>
        )
      }
    </div >
  );
}

export default HeroSection;